/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './image-upload.component.css.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../../app/core/angular2-image-upload/image-upload/image-upload.component';
import * as i4 from '../../../../../app/core/angular2-image-upload/file-drop.directive';
import * as i5 from '../../../../../app/core/angular2-image-upload/image.service';
const styles_ImageUploadComponent:any[] = [i0.styles];
export const RenderType_ImageUploadComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_ImageUploadComponent,data:{}});
function View_ImageUploadComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'label',[['class',
      'clear button'],['style','display: none']],(null as any),[[(null as any),'click']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.deleteAll()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i1.ɵeld(2,0,(null as any),(null as any),0,'span',([] as any[]),[[8,'innerText',
          0]],(null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
          (null as any),['\n    ']))],(null as any),(_ck,_v) => {
    const currVal_0:any = 'Clear';
    _ck(_v,2,0,currVal_0);
  });
}
function View_ImageUploadComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),20,'div',[['class',
      'file-upload hr-inline-group']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵted(-1,
      (null as any),['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
      1,(null as any),View_ImageUploadComponent_2)),i1.ɵdid(4,16384,(null as any),
      0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n\n    '])),(_l()(),i1.ɵeld(6,0,(null as any),
          (null as any),13,'div',[['class','box-inputfile']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
          ['\n      '])),(_l()(),i1.ɵeld(8,0,(null as any),(null as any),10,'label',
          [['style','cursor: pointer']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),
      (_l()(),i1.ɵeld(10,0,[[1,0],['input',1]],(null as any),0,'input',[['class','inputfile inputfile-6'],
          ['multiple',''],['type','file']],[[8,'accept',0]],[[(null as any),'change']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('change' === en)) {
              const pd_0:any = ((<any>_co.fileChange(i1.ɵnov(_v,10).files)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),
      (_l()(),i1.ɵeld(12,0,(null as any),(null as any),0,'i',[['class','icon icon-file icon-left']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵeld(14,0,(null as any),
          (null as any),3,'span',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n          '])),
      (_l()(),i1.ɵeld(16,0,(null as any),(null as any),0,'p',[['class','no-select select']],
          [[8,'innerText',0]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n      '])),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵted(-1,
          (null as any),['\n  ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = (_co.fileCounter > 0);
    _ck(_v,4,0,currVal_0);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = _co.supportedExtensions;
    _ck(_v,10,0,currVal_1);
    const currVal_2:any = _co.buttonCaption;
    _ck(_v,16,0,currVal_2);
  });
}
function View_ImageUploadComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'p',[['class',
      'file-too-large']],[[8,'innerText',0]],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  ']))],(null as any),(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.fileTooLargeMessage;
    _ck(_v,0,0,currVal_0);
  });
}
function View_ImageUploadComponent_6(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'div',[['class',
      'loading-overlay']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵeld(2,
      0,(null as any),(null as any),0,'div',[['class','spinningCircle']],(null as any),
      (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
      (null as any),['\n      ']))],(null as any),(null as any));
}
function View_ImageUploadComponent_7(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'div',[['class',
      'x-mark']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.deleteFile((<any>_v.parent).context.$implicit)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),
      (_l()(),i1.ɵeld(2,0,(null as any),(null as any),0,'span',[['class','close']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n      ']))],(null as any),(null as any));
}
function View_ImageUploadComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),9,'div',[['class',
      'image']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(1,278528,(null as any),0,i2.NgStyle,[i1.KeyValueDiffers,i1.ElementRef,
          i1.Renderer],{ngStyle:[0,'ngStyle']},(null as any)),i1.ɵpod(2,{'background-image':0}),
      (_l()(),i1.ɵted(-1,(null as any),['\n      '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_ImageUploadComponent_6)),i1.ɵdid(5,16384,
          (null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n      '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_ImageUploadComponent_7)),
      i1.ɵdid(8,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    ']))],
      (_ck,_v) => {
        const currVal_0:any = _ck(_v,2,0,(('url(' + _v.context.$implicit.src) + ')'));
        _ck(_v,1,0,currVal_0);
        const currVal_1:any = _v.context.$implicit.pending;
        _ck(_v,5,0,currVal_1);
        const currVal_2:boolean = !_v.context.$implicit.pending;
        _ck(_v,8,0,currVal_2);
      },(null as any));
}
function View_ImageUploadComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'div',[['class',
      'image-container hr-inline-group']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ImageUploadComponent_5)),
      i1.ɵdid(3,802816,(null as any),0,i2.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n  ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.files;
    _ck(_v,3,0,currVal_0);
  },(null as any));
}
export function View_ImageUploadComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(671088640,1,{inputElement:0}),(_l()(),i1.ɵeld(1,0,(null as any),
      (null as any),13,'div',[['class','image-upload'],['fileDrop','']],(null as any),
      [[(null as any),'isFileOver'],[(null as any),'fileDrop'],[(null as any),'dragover'],
          [(null as any),'dragleave'],[(null as any),'drop']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i3.ImageUploadComponent = _v.component;
        if (('dragover' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,4).onDragOver($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('dragleave' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,4).onDragLeave($event)) !== false);
          ad = (pd_1 && ad);
        }
        if (('drop' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,4).onDrop($event)) !== false);
          ad = (pd_2 && ad);
        }
        if (('isFileOver' === en)) {
          const pd_3:any = ((<any>_co.fileOver($event)) !== false);
          ad = (pd_3 && ad);
        }
        if (('fileDrop' === en)) {
          const pd_4:any = ((<any>_co.fileChange($event)) !== false);
          ad = (pd_4 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(2,278528,(null as any),0,i2.NgClass,
      [i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer],{klass:[0,
          'klass'],ngClass:[1,'ngClass']},(null as any)),i1.ɵpod(3,{'file-is-over':0}),
      i1.ɵdid(4,16384,(null as any),0,i4.FileDropDirective,([] as any[]),{accept:[0,
          'accept']},{isFileOver:'isFileOver',fileDrop:'fileDrop'}),(_l()(),i1.ɵted(-1,
          (null as any),['\n\n  '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_ImageUploadComponent_1)),i1.ɵdid(7,16384,(null as any),
          0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n\n  '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_ImageUploadComponent_3)),i1.ɵdid(10,16384,
          (null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n\n  '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_ImageUploadComponent_4)),
      i1.ɵdid(13,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i3.ImageUploadComponent = _v.component;
    const currVal_0:any = 'image-upload';
    const currVal_1:any = _ck(_v,3,0,_co.isFileOver);
    _ck(_v,2,0,currVal_0,currVal_1);
    const currVal_2:any = _co.supportedExtensions;
    _ck(_v,4,0,currVal_2);
    const currVal_3:any = (_co.fileCounter < _co.max);
    _ck(_v,7,0,currVal_3);
    const currVal_4:any = _co.showFileTooLargeMessage;
    _ck(_v,10,0,currVal_4);
    const currVal_5:any = _co.preview;
    _ck(_v,13,0,currVal_5);
  },(null as any));
}
export function View_ImageUploadComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'image-upload',
      ([] as any[]),(null as any),(null as any),(null as any),View_ImageUploadComponent_0,
      RenderType_ImageUploadComponent)),i1.ɵdid(1,114688,(null as any),0,i3.ImageUploadComponent,
      [i5.ImageService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ImageUploadComponentNgFactory:i1.ComponentFactory<i3.ImageUploadComponent> = i1.ɵccf('image-upload',
    i3.ImageUploadComponent,View_ImageUploadComponent_Host_0,{max:'max',url:'url',
        headers:'headers',preview:'preview',maxFileSize:'maxFileSize',withCredentials:'withCredentials',
        partName:'partName',buttonCaption:'buttonCaption',dropBoxMessage:'dropBoxMessage',
        fileTooLargeMessage:'fileTooLargeMessage',supportedExtensions:'extensions'},
    {isPending:'isPending',onFileUploadFinish:'onFileUploadFinish',onRemove:'onRemove'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/$$_gendir/app/core/angular2-image-upload/image-upload/image-upload.component.ngfactory.ts